import { Stack } from "@mui/material";

export const SearchEventAndOrganisationContainer: React.FCWithChildren<{
    className?: string;
}> = ({ children, className }) => (
    <Stack
        direction="column"
        spacing={2}
        maxWidth={(theme) => theme.breakpoints.values.md}
        mx="auto"
        className={className}
    >
        {children}
    </Stack>
);
